<template>
  <div>
    <div v-if="userInfo" style="margin: 1%">
      <b-row>
        <b-col md="6" xl="6" cols="6">
          <b-form-group label-align="right" :label="$t('WebPage')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
            <b-form-input type="text"  v-model="userInfo.web_page"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Legal address')" label-cols="4" label-cols-xl="4" label-cols-md="4"  >
            <b-form-input type="text"  v-model="userInfo.juridical_address" :disabled="!userInfo.is_juridical"/>
            <b-form-checkbox   v-model="userInfo.is_juridical">{{ $t('Legal person') }}</b-form-checkbox>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('House')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-input-group>
              <b-form-input type="text" v-model="userHouse" disabled :placeholder="$t('Tap to select')"/>
              <div style="position:absolute; left:0; right:0; top:0; bottom:0;" @click="showFormHouse"/>
              <b-input-group-append>
                <b-button @click.stop="clear" variant="secondary" size="sm">{{ $t('Clear') }}</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Actual address')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
            <b-form-textarea v-model="userInfo.actual_address" rows="2" />
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Registration address')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
            <b-form-textarea v-model="userInfo.registry_address" rows="2" />
          </b-form-group>
          <b-form-group label-align="right" :label="$t('District')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
            <b-form-input type="text"  v-model="userInfo.district"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Building')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
            <b-form-input type="text"  v-model="userInfo.building"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Porch')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
            <b-form-input type="text"  v-model="userInfo.entrance"/>
          </b-form-group>
        </b-col>
        <b-col md="6" xl="6" cols="6" align-self="center" >
          <b-form-group label-align="right" :label="$t('Floor')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
            <b-form-input type="number"  v-model="userInfo.floor"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Apartment')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
            <b-form-input type="text"  v-model="userInfo.flat_number"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Work phone')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
            <b-form-input type="text"  v-model="userInfo.work_telephone"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Home phone')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
            <b-form-input type="text"  v-model="userInfo.home_telephone"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Mobile phone')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
            <masked-input v-if="phoneFormat.length" type="text" class="form-control" v-model="userInfo.mobile_telephone" :mask="phoneFormat" />
            <b-form-input v-if="!phoneFormat.length" type="text"  v-model="userInfo.mobile_telephone"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Mobile phone secondary')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
            <masked-input v-if="phoneFormat.length" type="text" class="form-control" v-model="userInfo.mobile_telephone_second" :mask="phoneFormat" />
            <b-form-input v-if="!phoneFormat.length" type="text"  v-model="userInfo.mobile_telephone_second"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('ICQ number')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
            <b-form-input type="text"  v-model="userInfo.icq_number"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Email')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
            <b-form-input type="text"  v-model="userInfo.email" @change="changeEmail"/>
            <b-form-checkbox  v-model="userInfo.is_send_invoice" :disabled="!userInfo.email.length" false-value="">{{ $t('Send invoices by email') }}</b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <b-modal v-if="userInfo" ref="houseUser" hide-footer :title="$t('Buildings')" size="xl">
      <FormHouse v-model="userInfo.house_id" @hideFormHouse="hideFormHouse"></FormHouse>
    </b-modal>
  </div>
</template>

<script>
import FormHouse from './formHouse'
export default {
  components: {
    FormHouse
  },
  props: {
    currentRow: null,
    userInfo: null
  },
  methods: {
    changeEmail (newEmail) {
      if (!newEmail.length) {
        this.userInfo.is_send_invoice = false
      }
    },
    clear () {
      this.userHouse = ''
      this.userInfo.house_id = 0
    },
    showFormHouse () {
      this.$refs.houseUser.show()
    },
    hideFormHouse () {
      this.$refs.houseUser.hide()
    }
  },
  computed: {
    userHouse () {
      let userHouse = ''
      if (this.$store.getters['ReferenceBooks/BUILDINGS'].length > 0 && this.userInfo) {
        for (let el of JSON.parse(JSON.stringify(this.$store.getters['ReferenceBooks/BUILDINGS']))) {
          if (el.house_id === this.userInfo.house_id) {
            userHouse += '(' + el.house_id + ')'
            if (el.post_code.length > 0) {
              userHouse += el.post_code + ', '
            }
            if (el.country.length > 0) {
              userHouse += el.country + ', '
            }
            if (el.region.length > 0) {
              userHouse += el.region + ', '
            }
            if (el.city.length > 0) {
              userHouse += el.city + ', '
            }
            if (el.street.length > 0) {
              userHouse += el.street + ', '
            }
            if (el.number.length > 0) {
              userHouse += el.number + ', '
            }
            if (el.building.length > 0) {
              userHouse += el.building + ', '
            }
            break
          }
        }
      }
      return userHouse
    },
    phoneFormat () {
      return this.$store.getters['Settings/REGISTRY_SETTINGS_PHONE_FORMAT']
    }
  },
  watch: {
    userHouse: {
      deep: true,
      handler: function (newVal) {
        this.userInfo.actual_address = newVal
      }
    }
  },
  mounted () {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/contacts/main.vue